import type { ImageArray } from "@pdfking/compatibility"

export const ImageCompare = (
  a: ImageArray,
  b: ImageArray,
  tolerance: number = 3
): boolean => {
  if (a.width !== b.width || a.height !== b.height) {
    console.log(
      `ImageCompare: size mismatch ${a.width}x${a.height} vs ${b.width}x${b.height}`
    )
    return false
  }

  const dataA = a.data
  const dataB = b.data

  let maxDiff = 0
  let diffCount = 0
  for (let i = 0; i < dataA.length; i++) {
    const diff = Math.abs(dataA[i] - dataB[i])
    if (diff > maxDiff) maxDiff = diff
    if (diff > tolerance) diffCount++
  }

  if (diffCount > 0) {
    console.log(
      `ImageCompare: maxDiff=${maxDiff}, diffCount=${diffCount}, tolerance=${tolerance}`
    )
  }

  return diffCount === 0
}
